export enum SelectedStatus {
    Default = 0,
    Selected = 1
}

export enum Condition {
    Is = "is",
    Not = "not"
}

export enum ApplicantType {
    Individual = 0,
    Company = 1
}

export enum AttachmentType {
    Path = "Download",
    File = "FileProvider"
}

export enum Input {
    Text = "Text",
    TextArea = "TextArea",
    Select = "Select",
    Checkbox = "Checkbox",
    Number = "Number",
    Date = "Date",
    Phone = "Phone",
    Email = "Email",
    Label = "Label"
}

export enum DrawType {
    Point = "Point",
    Polyline = "Polyline",
    Polygon = "Polygon",

    PointText = "PointText",
    PolylineLvmRoad = "PolylineLvmRoad",
    PolygonProperty = "PolygonProperty"
}

export enum Result {
    Success = "Success",
    Error = "Error"
}

export enum PrintType {
    Path = 1,
    File = 2
}

export enum DropdownType {
    SingleLine = "SingleLine",
    MultiLine = "MultiLine"
}

export enum BaseMapsMode {
    default = "default",
    swipe = "swipe",
    opacity = "opacity"
}

export enum ImageRole {
    Thumbnail = "thumbnail",
    Original = "original",
    Fullscreen = "fullscreen"
}

export enum Widget {
    Search = "Search",
    Toc = "Toc",
    Print = "Print",
    Convert = "Convert",
    Draw = "Draw",
    Bookmarks = "Bookmarks",
    DataDownload = "DataDownload",
    MapDownload = "MapDownload",
    Help = "Help"
}

export enum GroupVisibility {
    VISIBLE = "visible",
    HIDDEN = "hidden",
    MIXED = "mixed"
}

export enum LayerAction {
    Expand = "expand",
    View = "view",
    Shown = "shown"
}

export enum LayerType {
    MapImageLayer = "MapImageLayer",
    TileLayer = "TileLayer",
    WMS = "WMS",
    WMTS = "WMTS",
    FeatureLayer = "FeatureLayer",
    ClusterLayer = "ClusterLayer",
    LayerGroup = "LayerGroup"
}

export enum SheetSelectMode {
    Click = "Click",
    Polygon = "Polygon"
}

export enum DrawingSection {
    Import = "Import",
    Export = "Export",
    Draw = "Draw",
    WMS = "WMS"
}
